import { useEffect, useLayoutEffect, useRef } from 'react';
import { NavigationType } from 'react-router-dom';
import { useNavigationBlockContext } from '|/context/navigation-block-context';

const useBrowserBackClose = (key: string, isOpen: boolean, onClose: () => void) => {
  const { addBlocker, removeBlocker } = useNavigationBlockContext();
  const onCloseRef = useRef(onClose);
  // The key is read when the guard arms and then held for the whole open lifetime. A modal may
  // change it while open — transfer-method derives its analyticsId from a sub-view state it resets
  // one render before isOpen flips — and re-registering there reads to the coordinator as a fresh
  // managed modal, which answers with a stray sentinel history entry.
  const keyRef = useRef(key);

  useLayoutEffect(() => {
    onCloseRef.current = onClose;
    keyRef.current = key;
  });

  useEffect(() => {
    if (!isOpen) return undefined;

    const armedKey = keyRef.current;
    addBlocker(
      armedKey,
      ({ historyAction }) => historyAction === NavigationType.Pop,
      () => onCloseRef.current(),
      { managed: true }
    );

    return () => {
      removeBlocker(armedKey);
    };
  }, [isOpen, addBlocker, removeBlocker]);
};

export default useBrowserBackClose;
